import { listen } from "@tauri-apps/api/event";
import { isScreenRecordingSessionActive } from "./screen-recording-store";

import {
  beginVoiceAttentionSession,
  clearVoiceAttentionSession,
  ingestVoiceAttentionGesture,
  ingestVoiceAttentionViewChange,
  type NativeVoiceAttentionViewChange,
  type VoiceAttentionPoint,
  useVoiceAttentionStore,
} from "./voice-attention-store";
import {
  clearVoiceAttentionChapterCaptures,
  pruneVoiceAttentionChapterCaptures,
  requestVoiceAttentionChapterCapture,
} from "./voice-attention-chapter-capture";

export const VOICE_ATTENTION_START_EVENT = "denker:voice-attention-start";
export const VOICE_ATTENTION_SESSION_EVENT = "voice-attention-session";
export const VOICE_ATTENTION_CLEAR_EVENT = "voice-attention-clear";

type NativeGestureEvent = {
  recordingId: string;
  clipId?: string | null;
  strokeId: string;
  phase: "start" | "move" | "end";
  tMs: number;
  displayId: VoiceAttentionPoint["displayId"] | null;
  x: number;
  y: number;
};

let listening = false;

export function useVoiceAttentionLifecycle(): void {
  if (listening) return;
  listening = true;
  void listen<{
    recordingId: string;
    activation: {
      display_id: number | null;
      x: number;
      y: number;
      source: "speak";
    };
  }>(VOICE_ATTENTION_SESSION_EVENT, (event) => {
    beginVoiceAttentionSession(
      event.payload.recordingId,
      event.payload.activation,
    );
  });
  void listen<{ recordingId: string }>(VOICE_ATTENTION_CLEAR_EVENT, (event) => {
    const current = useVoiceAttentionStore.getState().recordingId;
    clearVoiceAttentionChapterCaptures(event.payload.recordingId);
    if (current === event.payload.recordingId) {
      clearVoiceAttentionSession();
    }
  });
  void listen<NativeVoiceAttentionViewChange>(
    "voice-attention-view-change",
    (event) => {
      const chapter = ingestVoiceAttentionViewChange(event.payload);
      if (chapter && !event.payload.clipId && !isScreenRecordingSessionActive(event.payload.recordingId)) requestVoiceAttentionChapterCapture(chapter);
    },
  );
  void listen<NativeGestureEvent>("voice-attention-gesture", (event) => {
    if (event.payload.clipId) return;
    if (event.payload.phase === "start") {
      window.dispatchEvent(new Event(VOICE_ATTENTION_START_EVENT));
    }
    const result = ingestVoiceAttentionGesture(event.payload);
    if (!result) return;
    pruneVoiceAttentionChapterCaptures(
      event.payload.recordingId,
      result.evictedChapterIds,
    );
    requestVoiceAttentionChapterCapture(result.chapter);
  });
}
